import * as React from 'react';
import {Grid} from "@material-ui/core";
import {ChangeEvent} from "react";
import {Defaults} from "../../defaults/Defaults";
import {TextValidator} from 'react-material-ui-form-validator';
import {ICatalogo} from "../../entities/catalogos/ICatalogo";
import {useState} from "react";
import {useEffect} from "react";
import MenuItem from "@material-ui/core/MenuItem";
import useCommonApi from "../../api/useCommonApi";
import { traducirLabel } from '../../blocks/traductor';

interface Props {
    label: string
    value?: number
    name: string
    source?: string
    dataSource?: any[]
    onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const InputSelect = ({label, value, name, source = "", dataSource, onChange}: Props) => {
    const [data, setData] = useState<ICatalogo[]>([]);
    const validators: string[] = ['required'];
    const errorMessages: string[] = [traducirLabel(126)];
    const apiSource = useCommonApi();

    useEffect(() => {
        const getData = async () => {
            const result = await apiSource.obtenerAsync<ICatalogo[]>(source);
            setData(result);
        };

        if (dataSource) {
            setData(dataSource);
        } else
            getData();
    }, [dataSource, source]);

    return (<>
        <Grid item xs={12} sm={6} md={4}>
            {data.length > 0 &&
            <TextValidator
                label={label}
                value={value != null ? value : ""}
                name={name}
                select
                onChange={onChange}
                variant="filled"
                fullWidth
                validators={validators}
                errorMessages={errorMessages}
            >{data.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                    {option.nombre}
                </MenuItem>
            ))}
            </TextValidator>
            }
        </Grid>
    </>)
};

export default InputSelect;
